import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

export const FooterNav = forwardRef((props, ref) => {
  const { as = 'ul', title, children, flexDir, className, ...rest } = props

  const Comp = as

  const baseClass = 'dev_dash__footer-nav'
  const flexClass = flexDir ? `${baseClass}__${flexDir}` : ''
  const footerNavClasses = [baseClass, flexClass, className].filter(Boolean).join(' ')

  return (
    <>
      {title && <h3 className="dev_dash__footer-nav--title">{title}</h3>}
      <Comp className={footerNavClasses} ref={ref} {...rest}>
        {children}
      </Comp>
    </>
  )
})

FooterNav.displayName = 'FooterNav'

FooterNav.propTypes = {
  as: PropTypes.any,
  title: PropTypes.string,
  children: PropTypes.any.isRequired,
  flexDir: PropTypes.string,
  className: PropTypes.string,
}
